import React from 'react';

import {useTranslation} from 'react-i18next';

import {PermissionAccess} from 'components/common/PermissionAccess';
import {ButtonVariant} from 'components/ui-kit/Button';

import {history} from 'core/history';
import {ROUTE} from 'core/routes';

import {UserRoles} from 'types';

import {RecallButton} from '../Controls/styled';

export const RecallControl = () => {
    const {t} = useTranslation();
    return (
        <PermissionAccess permissions={[]} roleAccess={[UserRoles.ROLE_MPL_OPERATOR_ADMIN]}>
            <RecallButton
                size="sm"
                variant={ButtonVariant.Secondary}
                onClick={() => {
                    // isRecallModalOpenChanged(true);
                    history.push(ROUTE.REGISTRIES_RECALL);
                }}
            >
                {t('pages.registries.recall')}
            </RecallButton>
        </PermissionAccess>
    );
};
